import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';

import { AppActions } from '../../core/store/actions/app';
import { MessagesApi } from '../store/api/messages';

@Injectable()
export class MessagesEffects {
    loadMessages$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(AppActions.initialized),
                tap(() => this.messageAPI.getMessageForInstaller().subscribe()),
            ),
        { dispatch: false },
    );

    constructor(
        private actions$: Actions,
        private messageAPI: MessagesApi,
    ) {}
}
